(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-impact"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('section-{{ section.id }}');
  if (!root) return;

  /* ── Scroll-reveal ── */
  var revealEls = root.querySelectorAll('.ist__strip, .ist__stats');
  revealEls.forEach(function (el) { el.classList.add('js-hide'); });

  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.remove('js-hide');
      e.target.classList.add('js-show');
      revealObs.unobserve(e.target);
    });
  }, { threshold: 0.1 });

  revealEls.forEach(function (el) { revealObs.observe(el); });

  /* ── Count-up animation ── */
  var counters = root.querySelectorAll('.ist__num[data-target]');
  if (!counters.length) return;

  var countObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el     = e.target;
      var end    = parseInt(el.getAttribute('data-target'), 10);
      var suffix = el.getAttribute('data-suffix') || '';
      if (isNaN(end)) return;

      var duration = 1500;
      var startTs  = null;

      function tick(ts) {
        if (!startTs) startTs = ts;
        var prog  = Math.min((ts - startTs) / duration, 1);
        var eased = 1 - Math.pow(1 - prog, 3);
        el.textContent = Math.round(eased * end) + suffix;
        if (prog < 1) requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
      countObs.unobserve(el);
    });
  }, { threshold: 0.5 });

  counters.forEach(function (el) { countObs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  // Horizon emits the compiled javascript-tag bundle before the deferred bs-global.js
  // (which defines debounce/fetchConfig), so wait for it when it has not run yet.
  function bsDefineCartNote() {
    if (!customElements.get('bs-cart-note')) customElements.define('bs-cart-note', CartNote);
  }
  if (typeof debounce === 'function') bsDefineCartNote();
  else document.addEventListener('DOMContentLoaded', bsDefineCartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
              this.refreshSlider();
              window.setTimeout(() => this.refreshSlider(), 120);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }

    refreshSlider() {
      const section = this.closest('[data-section-type="product-slider"]');
      const slider = section?.querySelector('.productSlider.swiper');

      if (!slider || !slider.swiper) return;

      window.requestAnimationFrame(() => {
        const prevButton = section.querySelector('.swiper-button-prev');
        const nextButton = section.querySelector('.swiper-button-next');

        if (typeof slider.swiper.loopDestroy === 'function') {
          slider.swiper.loopDestroy();
        }

        slider.swiper.update();

        if (typeof slider.swiper.loopCreate === 'function') {
          slider.swiper.loopCreate();
        }

        slider.swiper.update();

        if (slider.swiper.navigation) {
          slider.swiper.params.navigation.prevEl = prevButton;
          slider.swiper.params.navigation.nextEl = nextButton;

          if (typeof slider.swiper.navigation.destroy === 'function') {
            slider.swiper.navigation.destroy();
          }

          if (typeof slider.swiper.navigation.init === 'function') {
            slider.swiper.navigation.init();
          }

          if (typeof slider.swiper.navigation.update === 'function') {
            slider.swiper.navigation.update();
          }
        }

        if (typeof slider.swiper.slideToLoop === 'function') {
          slider.swiper.slideToLoop(0, 0, false);
        } else {
          slider.swiper.slideTo(0, 0, false);
        }

        this.applyMobileAutoplay(slider);
        this.bindArrowFallback(section, slider);
      });
    }

    applyMobileAutoplay(slider) {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      if (!slider.swiper.autoplay) return;

      if (isMobile) {
        slider.swiper.params.autoplay = {
          delay: 2600,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        };

        if (!slider.swiper.autoplay.running) {
          slider.swiper.autoplay.start();
        }
      } else if (slider.swiper.autoplay.running && slider.closest('[data-autoplay="true"]') === null) {
        slider.swiper.autoplay.stop();
      }
    }

    bindArrowFallback(section, slider) {
      const prevButton = section.querySelector('.swiper-button-prev');
      const nextButton = section.querySelector('.swiper-button-next');

      if (prevButton && prevButton.dataset.recommendationArrowBound !== 'true') {
        prevButton.dataset.recommendationArrowBound = 'true';
        prevButton.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          slider.swiper.slidePrev();
        });
      }

      if (nextButton && nextButton.dataset.recommendationArrowBound !== 'true') {
        nextButton.dataset.recommendationArrowBound = 'true';
        nextButton.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          slider.swiper.slideNext();
        });
      }
    }
  }

  customElements.define('bs-product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
